import * as React from "react";
const CalendarCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <rect width={72} height={72} fill="#CEBDF1" rx={10} />
        <rect
            width={13.609}
            height={15.696}
            x={29.205}
            y={29.432}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <rect
            width={14.652}
            height={15.696}
            x={28.674}
            y={28.62}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <rect
            width={15.696}
            height={15.696}
            x={28.152}
            y={27.891}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <path
            fill="#000"
            stroke="#000"
            d="M28.192 30.544a3.153 3.153 0 0 1 3.113-2.653h8.87a3.153 3.153 0 0 1 3.112 2.653H28.192Z"
        />
        <path
            fill="#0EAA15"
            d="m34.901 37.64-1.37-1.37a.385.385 0 0 0-.547 0 .385.385 0 0 0 0 .548l1.64 1.64a.39.39 0 0 0 .551 0l4.148-4.144a.385.385 0 0 0 0-.548.385.385 0 0 0-.548 0l-3.873 3.874Z"
        />
        <rect
            width={1.087}
            height={2.13}
            x={30.239}
            y={26.848}
            fill="#fff"
            stroke="#000"
            rx={0.543}
        />
        <rect
            width={1.087}
            height={2.13}
            x={40.674}
            y={26.848}
            fill="#fff"
            stroke="#000"
            rx={0.543}
        />
        <rect
            width={27}
            height={31}
            x={23.064}
            y={22.759}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <rect
            width={29}
            height={31}
            x={22.047}
            y={21.202}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <rect
            width={31}
            height={31}
            x={21.047}
            y={19.806}
            fill="#fff"
            stroke="#000"
            rx={3.5}
        />
        <path
            fill="#000"
            stroke="#000"
            d="M21.047 23.306a3.5 3.5 0 0 1 3.5-3.5h23a3.5 3.5 0 0 1 3.5 3.5v2.5h-30v-2.5Z"
        />
        <path
            fill="#0EAA15"
            d="m34.441 38.95-2.625-2.624a.738.738 0 0 0-1.05 0 .738.738 0 0 0 0 1.05l3.143 3.142a.747.747 0 0 0 1.057 0l7.95-7.942a.738.738 0 0 0 0-1.05.738.738 0 0 0-1.05 0l-7.425 7.425Z"
        />
        <rect
            width={3}
            height={5}
            x={25.047}
            y={17.806}
            fill="#fff"
            stroke="#000"
            rx={1.5}
        />
        <rect
            width={3}
            height={5}
            x={45.047}
            y={17.806}
            fill="#fff"
            stroke="#000"
            rx={1.5}
        />
    </svg>
);
export default CalendarCheckIcon;
